<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import FormErrors from "@shared/svelte/Components/FormErrors.svelte";
  import Flash from "@shared/services/flashv2.js";
  import ChatWithSupportLink from "@shared/svelte/Components/ChatWithSupportLink.svelte";
  import ProductImage from "@shared/svelte/Components/ProductImage.svelte";
  import productContainerDetails from "@shared/filters/product_container_details.js";
  import { Http } from "@shared/svelte/Modules/ApiService";
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
  import { get as getStoreValue } from "svelte/store";

  import type { Product, ProductLine, LimitedOrderingProduct } from "@shared/types/ProductLine";
  import type { Errors } from "@shared/types/Errors";

  export let product: Product;
  export let productLine: ProductLine;
  export let requestable: boolean = false;
  export let open: boolean = false;
  let errors: Errors;
  let submitting: boolean = false;

  const closeModal = () => {
    open = false;
  };

  let currentUser: any = getStoreValue(CurrentUserStore);

  let limitedOrderingProduct: LimitedOrderingProduct = {};
  let canAddOwn = currentUser?.role === "group_director";

  const requestData = function () {
    if (canAddOwn) {
      return {
        limited_ordering_product: {
          product_id: product.id,
          request_note: limitedOrderingProduct.note,
          approve_now: canAddOwn,
        },
      };
    } else {
      return {
        product_id: product.id,
        request_note: limitedOrderingProduct.note,
      };
    }
  };

  const request = function () {
    submitting = true;

    const requestUrl = canAddOwn
      ? "/api/retailer/limited_ordering_products"
      : "/api/retailer/limited_ordering_product_requests";

    Http(
      {
        method: "POST",
        url: requestUrl,
        data: requestData(),
      },
      function () {
        if (canAddOwn) {
          Flash.queue({
            message: "This product has been added to your ordering list.",
            type: "success",
          });
        } else {
          Flash.queue({ message: "Your request was submitted.", type: "success" });
        }
        window["stateService"].reload();
      },
      function (res: any) {
        errors = res.data;
        submitting = false;
      },
    );
  };
</script>

<FormErrors {errors} />
<Modal bind:show={open}>
  <div
    class="background-white welcome-modal limited-ordering-request-modal padding--medium"
    style="width: 90vw; max-width: 600px;"
  >
    <div class="problematic-choice-modal__header full-width">
      <div class="media-fixed align-right float-right">
        <Icon
          type="X"
          height="16"
          width="16"
          extraClassNames="cursor-pointer close-modal"
          onPress={closeModal}
        />
      </div>
      <div
        class="default-title--regular margin-top--smaller margin-bottom--smallest notranslate float-left"
      >
        {#if canAddOwn}
          <span>Add this item to a list for this location to order?</span>
        {:else}
          <span>Request Approval</span>
        {/if}
      </div>
      <hr class="hr clear hr-card-separator--header margin-bottom--smallest" />
      <span class="s6 full-width align-center">
        If you want to add this item for all locations to order, please <ChatWithSupportLink
          message={"reach out to customer service"}
          brandprimary={true}
        />.
      </span>
    </div>

    <div
      class="product-result-tile__container margin-top--smallest"
      product-line-id={product.id}
      class:product-result-tile--sku={product}
      class:fizz-stack-24={requestable}
    >
      {#if product && product.id}
        <div class="product-result-tile-no-hover">
          <div class="product-result-tile__flex-container">
            <ProductImage
              width={150}
              height={210}
              product={productLine}
              className={"product-result-tile__image"}
            />
            <!-- <div class="product-result-tile__image" product-image-style product-line='productLine' width='150' height='210'></div> -->
            <div class="product-result-tile__title default-subheader--regular">
              <span class="notranslate">{productLine.name}</span>
            </div>
            <div class="product-result-tile__package-info secondary-body--regular s6">
              <span class="strong">Size:</span>
              {productContainerDetails()(product, null, null, true)}
            </div>
          </div>
        </div>
      {/if}
    </div>

    {#if requestable}
      <div class="fizz-alert-warning">
        <div class="fizz--alert-links">
          <p
            >If your corporation approves this item, you must then request it from the distributor.
            You will receive this item only if the distributor chooses to fulfill this request.
          </p>
        </div>
      </div>
    {/if}

    <div class="problematic-choice-modal_distributor-container full-width">
      <div class="grid-row">
        {#if !canAddOwn}
          <div class="grid-col c12-12">
            <div class="label input__label--left padding-bottom--smallest margin-top--small">
              Add a Note
            </div>
            <div class="input-wrapper full-width textarea margin-bottom--smaller">
              <textarea
                class="input"
                placeholder="Enter a note"
                ng-model="limitedOrderingProduct.note"
                bind:value={limitedOrderingProduct.note}
              />
            </div>
          </div>
        {/if}
      </div>
    </div>
    <div class="problematic-choice-modal__bottom-actions full-width">
      <hr class="hr hr-card-separator--header" />
      <button
        class="button button--secondary margin-top--small margin-bottom--smaller float-left"
        on:click={closeModal}
      >
        Cancel
      </button>
      <button
        class="align-right button button--primary margin-top--small margin-bottom--smaller float-right"
        on:click={request}
        disabled={submitting}
        id="request-button"
      >
        {#if canAddOwn}
          <span>Add</span>
        {:else}
          <span>Submit</span>
        {/if}
      </button>
    </div>
  </div>
</Modal>
